import { useState } from 'react'
import Collapsible from 'react-collapsible'
import { capitalize } from 'lodash'
import './dealmedAccordion.scss'

const FAQAccordion = ({ faqs, categories }) => {
  const [selectedFAQfilter, setSelectedFAQfilter] = useState('general')

  const Categories = ({ categs }) => {
    return (
      <div div className="categories">
        {categs.map((cat, i) => {
          return (
            <button
              key={i}
              onClick={() => setSelectedFAQfilter(cat)}
              className={cat === selectedFAQfilter ? 'is-active' : 'not-active'}
            >
              {capitalize(cat)}
            </button>
          )
        })}
      </div>
    )
  }

  const filteredQuestions =
    categories?.length > 0 ? faqs.filter(question => question.cat === selectedFAQfilter) : faqs

  const FinalQuestions = () => {
    return filteredQuestions.map(question => {
      return <Collapsible trigger={question.q}>{question.a}</Collapsible>
    })
  }

  return (
    <div className="accordion-new-layout">
      {categories && categories.length > 0 && <Categories categs={categories} />}
      <FinalQuestions />
    </div>
  )
}

export default FAQAccordion
